var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4736 2.29716C12.6639 2.48748 12.7708 2.74559 12.7708 3.01471C12.7708 3.28383 12.6639 3.54193 12.4736 3.73226L7.44972 8.75613L12.4736 13.78C12.6585 13.9714 12.7608 14.2278 12.7585 14.4939C12.7561 14.76 12.6494 15.0146 12.4612 15.2027C12.2731 15.3909 12.0185 15.4976 11.7524 15.5C11.4863 15.5023 11.2299 15.4 11.0385 15.2151L5.29707 9.47368C5.1068 9.28335 4.99992 9.02525 4.99992 8.75613C4.99992 8.48701 5.1068 8.2289 5.29707 8.03858L11.0385 2.29716C11.2288 2.10689 11.4869 2 11.756 2C12.0252 2 12.2833 2.10689 12.4736 2.29716Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.4e24410a447362da7d11e16c11e17b0a.svg";
export { ForwardRef as ReactComponent };